var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletEmptyError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 350 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h350v300h-350z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m235.718 289.323c0 2.138-27.509 3.871-61.444 3.871s-61.446-1.733-61.446-3.871c0-2.136 27.511-3.87 61.446-3.87s61.444 1.734 61.444 3.87",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.513 40.6407c-33.52 2.8375-45.839 31.2094-35.747 47.7476 7.122 11.6687 19.189 27.4387 41.684 23.6557 22.493-3.784 24.388-24.6009 12.542-27.4325-11.846-2.8307-54.05 10.3756-49.28 40.8845 3.443 22.013 33.286 28.358 33.286 28.358",
    stroke: "#edf0f7",
    strokeDasharray: 7,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m185.886 23.2233s4.803-12.5468 5.309-17.42763c.267-2.55039-3.96-9.65123-8.906-3.08295s-2.69 14.62178 3.597 20.51058",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m168.843 9.55898c-5.627-1.90283-8.174-.41924-9.259 2.54202-1.087 2.9623.429 8.6007 8.916 9.8861 8.488 1.2853 16.902 1.236 16.902 1.236s-10.933-11.7613-16.559-13.66412",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m184.933 25.7093c.128-.5244.297-1.0271.485-1.5184-1.039.1641-2.096.3946-3.16.7066-1.154.3376-2.231.7805-3.244 1.2879-.439.8309-.796 1.7186-1.027 2.6717-1.426 5.8679 1.94 11.7823 7.596 13.7189.613-.1214 1.228-.2617 1.844-.4419 1.723-.5046 3.311-1.1723 4.748-1.9462-5.523-2.4232-8.702-8.4703-7.242-14.4786",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m176.858 28.7695c.135-.5797.318-1.134.521-1.6756-4.893 3.1346-7.633 7.9995-7.181 10.8364-3.126 1.3438-5.118 2.4759-5.118 2.4759s2.359-.1796 5.797-.8403c1.841 2.6906 6.945 4.4921 12.588 3.8461-5.112-2.6437-7.998-8.6602-6.607-14.6425",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m192.91 31.0326c-1.209-.2914-1.959-1.5109-1.668-2.7323.291-1.2131 1.513-1.9648 2.721-1.6734 1.215.2932 1.958 1.5174 1.668 2.7314-.292 1.2204-1.505 1.9666-2.721 1.6743m-5.65-6.7183c-.241.5598-.446 1.1504-.592 1.7621-1.283 5.3629 1.68 10.7575 6.705 12.6286 4.193-2.6199 6.547-6.3297 5.592-9.5507-1.062-3.6131-5.945-5.479-11.705-4.84z",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m116.461 250.618h120.498c3.055 0 5.532-2.483 5.532-5.546v-80.821c0-3.07-2.483-5.558-5.545-5.558h-123.409c-1.461 0-2.644 1.186-2.644 2.651v83.692c0 3.083 2.492 5.582 5.568 5.582",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m116.387 249.651h14.622c.112 0 .204-.092.204-.205v-102.161c0-.113-.092-.204-.204-.204h-14.622c-3.035 0-5.494 2.452-5.494 5.478v91.614c0 3.025 2.459 5.478 5.494 5.478",
    fill: "#dee4f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m212.194 215.783h37.836c.112 0 .203-.093.203-.207v-22.809c0-.115-.091-.207-.203-.207h-37.836c-3.04 0-5.505 2.495-5.505 5.571v12.081c0 3.077 2.465 5.571 5.505 5.571z",
    fill: "#f66d6a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m220.52 147.081h-104.001v.014c-3.118.075-5.626 2.632-5.626 5.792s2.508 5.718 5.626 5.793v.013h110.285c.113 0 .205-.092.205-.206v-4.869c0-3.61-2.906-6.537-6.489-6.537",
    fill: "#d4dbec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m225.075 204.171c0 2.673-2.166 4.839-4.838 4.839-2.673 0-4.839-2.166-4.839-4.839 0-2.672 2.166-4.838 4.839-4.838 2.672 0 4.838 2.166 4.838 4.838",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#edf0f7",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.709 179.981v2.903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9023 182.884 1.9353 1.935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 188.689h2.9029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9023 194.495 1.9353-1.935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.709 197.398v-2.903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.5154 194.495-1.9353-1.935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.4166 188.689h-2.9029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.5154 182.884-1.9353 1.935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.725 60.9612v1.9353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.887 65.7993h1.935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.725 71.6052v-1.9353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.531 66.767h-1.935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.2852 137.405v2.902"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5762 146.113h2.9029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.3164 153.854v-2.903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.026 146.113h-2.903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.683 239.006c2.137 0 3.871 1.733 3.871 3.871s-1.734 3.871-3.871 3.871-3.871-1.733-3.871-3.871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.003 291.782c.494 3.455-1.895 6.658-5.333 7.153-3.437.495-6.625-1.904-7.117-5.36-.493-3.456 1.894-6.659 5.333-7.154"
  })), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m285.068 202.236c2.346-.742 5.942-3.647 6.774-6.773.755 2.763 3.918 6.031 6.773 6.279-3.213 1.153-6.285 4.578-6.773 7.268-.332-2.742-4.581-6.375-6.774-6.774",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m42.1914 237.554c1.1734-.37 2.9709-1.823 3.3872-3.386.3771 1.381 1.9583 3.016 3.3863 3.14-1.607.576-3.1432 2.288-3.3863 3.634-.1665-1.371-2.2903-3.188-3.3872-3.388",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m63.4797 109.343c0 1.604-1.3 2.903-2.903 2.903-1.6038 0-2.9029-1.299-2.9029-2.903s1.2991-2.903 2.9029-2.903c1.603 0 2.903 1.299 2.903 2.903",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m342.159 103.537c0 2.138-1.732 3.871-3.87 3.871-2.139 0-3.871-1.733-3.871-3.871s1.732-3.8704 3.871-3.8704c2.138 0 3.87 1.7324 3.87 3.8704",
    fill: "#edf0f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m119.603 89.0227c0 1.6038-1.3 2.9029-2.903 2.9029-1.604 0-2.903-1.2991-2.903-2.9029 0-1.6039 1.299-2.9029 2.903-2.9029 1.603 0 2.903 1.299 2.903 2.9029z",
    fillRule: "evenodd",
    stroke: "#edf0f7",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m74.5317 272.62c-1.9975.76-4.2323-.243-4.9922-2.241-.7609-1.997.2432-4.232 2.2407-4.992 1.9974-.761 4.2322.243 4.9921 2.241.7599 1.997-.2432 4.232-2.2406 4.992z",
    fillRule: "evenodd",
    stroke: "#edf0f7",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletEmptyError);
export default __webpack_public_path__ + "static/media/WalletEmptyError.57a94f2b613f99dec61e6be08ab37dce.svg";
export { ForwardRef as ReactComponent };